import { render, staticRenderFns } from "./supplierDocumentsList.vue?vue&type=template&id=bfb6324a&scoped=true&"
import script from "./supplierDocumentsList.vue?vue&type=script&lang=js&"
export * from "./supplierDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./supplierDocumentsList.vue?vue&type=style&index=0&id=bfb6324a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb6324a",
  null
  
)

export default component.exports